export default __webpack_public_path__ + "static/media/SaveTheWhale_00.63e6b77a.png";